import { render, staticRenderFns } from "./circuit-tabs.vue?vue&type=template&id=dc4c52c2"
import script from "./circuit-tabs.vue?vue&type=script&lang=ts"
export * from "./circuit-tabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports